import { useEffect, useState} from "react";
import {useInnloggetBruker} from "../api/innloggetbruker";

export function classes(...classes: Array<string | null | undefined | false>) {
    return classes.filter(Boolean).join(' ')
}

export function useUsername() {
    const [innloggetBruker] = useInnloggetBruker()
    return innloggetBruker?.navn?.fulltNavn
}

type UseAsyncState = 'pending' | 'ready' | 'error' | undefined
type UseAsyncResult<T> = T | undefined
type UseAsyncError = unknown | undefined

export function useAsync<T>(fn: (...args: any[]) => Promise<T>, useMemoization: boolean = true) {
    let promise: Promise<T> | undefined

    return function (...args: any[]): [UseAsyncResult<T>, UseAsyncState, UseAsyncError, () => void] {
        const [result, setResult] = useState<UseAsyncResult<T>>(undefined)
        const [error, setError] = useState<UseAsyncError>(undefined)
        const [state, setState] = useState<UseAsyncState>(undefined)
        useEffect(() => {
            if(state !== undefined) return
            setState('pending')
            if(!promise || !useMemoization) {
                promise = fn(...args)
            }
            promise.then((result) => {
                setResult(result)
                setState('ready')
            })
            .catch((err) => {
                setState('error')
                setError(err)
                throw err //nå veit vi strengt tatt ikke lenger om den faktisk blir handled, men kaster den likevel videre så den plukkes opp av konsollen og feilrapporteringa
            })
        }, [state])

        const reset = () => {
            promise = undefined
            setState(undefined)
            setError(undefined)
            setResult(undefined)
        }
        return [result, state, error, reset]
    }
}

export function goToUrl(url: string) {
    window.open(url, '_self');
}

export function isLoadingStatus(status: UseAsyncState): boolean {
    return status === 'pending' || status === undefined;
}